<template>
  <div class="setting_modal">
    <div class="setting_customize">
      <div class="setting_customize_header">
        <p class="setting_customize_header_title" v-if="optionCustomizeColor === 2">
          {{ labelProperties.HEAD_MODAL }}
        </p>
        <p class="setting_customize_header_title" v-if="optionCustomizeColor === 1">
          {{ labelProperties.HEAD_EDIT_DELETE_THEME }}
        </p>
        <div class="setting_customize_header_close" @click="cancel">
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#AAA" fill-rule="evenodd">
              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
            </g>
          </svg>
        </div>
      </div>
      <div class="setting_customize_body">
        <div class="setting_customize_menu">
          <div class="setting_customize_menu_heading">
            <p class="setting_customize_menu_title">
              {{ labelProperties.MENU_THEME_NAME_TITLE }}
            </p>
            <p class="setting_label">{{ labelProperties.LABEL_REQUIRE }}</p>
          </div>
          <div class="setting_customize_menu_item">
            <input
              class="setting_form_text"
              type="text"
              :placeholder="labelProperties.PLACE_HOLDER"
              v-model="draftColors.themeName"
              ref="themeName"
            />
            <p v-if="isEmptyThemeName" class="empty-theme-name">
              {{ messageProperties.MESSAGE_EMPTY_THEME_NAME }}
            </p>
            <p v-if="isOverThemeNameLength" class="empty-theme-name">
              {{ maxlengthProperties.MAX_LENGTH_THEME_NAME
              }}{{ messageProperties.MESSAGE_OVER_LENGTH_THEME_NAME }}
            </p>
          </div>
          <div class="setting_customize_menu_heading">
            <p class="setting_customize_menu_title">
              {{ labelProperties.MENU_COLOR_TITLE }}
            </p>
          </div>
          <div
            class="setting_customize_menu_item"
            v-for="(colorSetting, index) in colorSettings"
            :key="index"
          >
            <p class="setting_customize_menu_label">{{ colorSetting.name }}</p>
            <div class="setting_form_color">
              <input
                class="setting_form_color_picker"
                type="color"
                v-model="colorSetting.color"
                @input="
                  handleChangeColor(colorSetting.name, colorSetting.color)
                "
              />
              <input
                class="setting_form_color_name"
                type="text"
                v-model="colorSetting.color"
                @input="
                  handleChangeColor(colorSetting.name, colorSetting.color)
                "
              />
            </div>
          </div>
        </div>

        <div
          class="setting_customize_preview"
          v-bind:style="{ backgroundColor: draftColors.pageBackground }"
        >
          <div class="jobs_wrapper" id="top_modal_customize">
            <template v-if="step === 1">
              <h1
                class="jobs_page_title_preview setting_word_break"
                v-bind:style="{ color: draftColors.pageText }"
                v-if="jobPageName"
              >
                {{ jobPageName }}
              </h1>
              <h1
                class="jobs_page_title"
                v-bind:style="{ color: draftColors.pageText }"
                v-else
              >
                {{ labelProperties.JOB_PAGE_TITLE }}
              </h1>
              <p class="jobs_table_annotation_preview setting_word_break" v-if="jobOverview">{{ jobOverview }}</p>
              <div class="jobs_table_wrapper">
                <template v-for="(category, indexOfCategory) in categoriesSearchJob">
                  <template v-if="category && !category.categoryDeleted && !isEmptyCategoryInJobSearch(indexOfCategory)">
                    <h2 class="jobs_category_title mt-3" v-bind:key="indexOfCategory"
                    v-bind:style="{color: draftColors.pageText, borderLeftColor: draftColors.keyColor}">
                      {{ category.categoryName }}
                    </h2>
                    <template v-for="(item, index) in category.item">
                      <table
                        class="jobs_table"
                        :key="'c_' + indexOfCategory + 'i_' + index"
                        v-bind:style="{ backgroundColor: draftColors.pageBackground }"
                      >
                        <tbody class="jobs_table_body" v-if="!item.itemDeleted && !item.resourceField[0].isItemDeletedByMainSystem">
                          <tr class="jobs_table_rows">
                            <th
                              class="jobs_table_head"
                              v-bind:style="[
                                { backgroundColor: draftColors.subColor },
                                index === 0
                                  ? { border: '1px solid' + draftColors.borderColor }
                                  : {
                                      borderLeft: '1px solid' + draftColors.borderColor,
                                      borderRight:
                                        '1px solid' + draftColors.borderColor,
                                      borderBottom:
                                        '1px solid' + draftColors.borderColor,
                                    },
                              ]"
                            >
                              <div class="jobs_table_head_holder">
                                <span
                                  class="jobs_table_label"
                                  v-bind:style="{ color: draftColors.pageText }"
                                >
                                   {{ item.itemName }}
                                 </span>
                              </div>
                            </th>
                            <td
                              class="jobs_table_cell"
                              v-bind:style="[
                                index === 0
                                  ? { border: '1px solid' + draftColors.borderColor }
                                  : {
                                      borderLeft: '1px solid' + draftColors.borderColor,
                                      borderRight:
                                        '1px solid' + draftColors.borderColor,
                                      borderBottom:
                                        '1px solid' + draftColors.borderColor,
                                    },
                              ]"
                            >
                              <div class="jobs_table_form_rows">
                                <div class="jobs_table_form_item">
                                  <InputComponent
                                    class="mt-3"
                                    :resource="item.resourceField[0]"
                                    :master="getMasterData(item.resourceField[0].master_name)"
                                    :itemJob="true"
                                    :draftColors="draftColors"
                                     :itemName="item.itemName"
                                  />
                                  <div
                                    v-if="item.viewAnnotation && item.annotationText"
                                  >
                                    <span v-bind:style="{ color: draftColors.pageText }" class="jobs_table_annotation setting_word_break">
                                       ※{{ item.annotationText }}
                                     </span>
                                  </div>
                                 </div>
                               </div>
                            </td>
                          </tr>
                         </tbody>
                       </table>
                     </template>
                  </template>
                </template>
                <h2 class="jobs_category_title mt-3"
                    v-bind:style="{color: draftColors.pageText, borderLeftColor: draftColors.keyColor}">
                  {{ labelProperties.CATEGORY_FREE_WORD }}
                </h2>
                <table class="jobs_table">
                 <table class="jobs_table">
                   <tbody class="jobs_table_body">
                    <tr class="jobs_table_rows">
                      <th
                        class="jobs_table_head"
                        v-bind:style="{
                          backgroundColor: draftColors.subColor,
                          borderLeft: '1px solid' + draftColors.borderColor,
                          borderBottom: '1px solid' + draftColors.borderColor,
                          borderTop: '1px solid' + draftColors.borderColor
                        }"
                      >
                        <div class="jobs_table_head_holder">
                          <span
                            class="jobs_table_label"
                            v-bind:style="{ color: draftColors.pageText }"
                            >{{ labelProperties.FREE_WORD_SEARCH }}</span
                          >
                        </div>
                      </th>
                      <td
                        class="jobs_table_cell"
                        v-bind:style="{
                          border: '1px solid' + draftColors.borderColor
                        }"
                      >
                        <div class="jobs_table_form_rows">
                          <div class="jobs_table_form_item mt-3">
                            <input
                               class="jobs_form_text"
                               type="text"
                               v-model="freeWord"
                              :placeholder="
                                labelProperties.PLACE_HOLDER_WORD_SEARCH
                              "
                            />
                          </div>
                         </div>
                        <div class="jobs_table_form_rows">
                          <div class="jobs_table_form_item">
                            <div class="jobs_table_form_label_box">
                              <label class="setting_form_radio_label">
                                <input
                                   type="radio"
                                   v-model="condition"
                                   id="and"
                                   value="and"
                                />
                                <span
                                  v-bind:style="{ color: draftColors.pageText }"
                                  for="and"
                                  class="setting_form_radio_text"
                                  >{{ labelProperties.AND }}</span
                                >
                              </label>
                              <label class="setting_form_radio_label">
                                <input
                                   type="radio"
                                   v-model="condition"
                                   id="or"
                                   value="or"
                                />
                                <span
                                  v-bind:style="{ color: draftColors.pageText }"
                                  for="or"
                                  class="setting_form_radio_text"
                                  >{{ labelProperties.OR }}</span
                                >
                              </label>
                              <span
                                class="ml-3 jobs_table_annotation"
                                v-bind:style="{ color: draftColors.pageText }"
                                >{{ labelProperties.NOTICE_FREE_WORD }}</span
                              >
                            </div>
                           </div>
                         </div>
                      </td>
                    </tr>
                   </tbody>
                 </table>
                 <div class="jobs_annotation_box">
                   <p class="jobs_annotation_text">
                     {{ labelProperties.NOTICE_CANT_SEARCH_COMBINATION }}
                   </p>
                 </div>
                 <div class="jobs_btn_box">
                  <button
                    class="jobs_btn_primary mt-5"
                    v-bind:style="{
                      color: draftColors.mainButtonText,
                      backgroundColor: draftColors.mainButton,
                      border: '1px solid' + draftColors.borderColor,
                    }"
                    @click="searchJob()"
                  >
                    <span v-if="!button.searchBtn">
                      {{ labelProperties.CONFIRM_BUTTON }}
                    </span>
                    <span v-else>
                      {{ button.searchBtn }}
                    </span>
                  </button>
                </div>
                </table>
              </div>
            </template>

            <template v-if="step === 2">
              <h1 class="jobs_page_title">
                {{ searchJobLabelsProperty.SEARCH_RESULT_LIST }}
              </h1>
              <h2 class="jobs_category_title">
                {{ searchJobLabelsProperty.CURRENT_SEARCH_CRITERIA }}
              </h2>
              <div class="jobs_search_condition">
                <div class="jobs_search_condition_inner">
                  <template v-if="!freeWord">
                    <template v-for="(category, indexOfCategory) in categoriesSearchJob">
                      <dl class="jobs_search_condition_list" :key="'c' + indexOfCategory">
                        <template v-for="(item, indexOfItem) in category.item">
                          <template v-if="!item.resourceField[0].isDeletedByMainSystem && item.resourceField[0].isHasValue">
                            <dt class="jobs_search_condition_label setting_word_break" :key="'c' + indexOfCategory + 'i' + indexOfItem">
                              {{ item.itemName }}
                            </dt>
                            <dd class="jobs_search_condition_desc setting_word_break" :key="'ci' + indexOfCategory + indexOfItem">
                              <span v-if="item.resourceField[0].default_value && (item.resourceField[0].type === 'text' || item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'url' || item.resourceField[0].type.includes('email')) || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'sequence'">
                                {{ item.resourceField[0].default_value }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value && (item.resourceField[0].type === 'multi_select' || item.resourceField[0].type === 'checkbox') && item.resourceField[0].default_value.length > 0">
                                {{ getValueCheckBox(item.resourceField[0].default_value) }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value !== null && (item.resourceField[0].type === 'single_select' || item.resourceField[0].type === 'select' || item.resourceField[0].type === 'boolean' || item.resourceField[0].type === 'radio')">
                                {{ getSingleSelect(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'datetime'">
                                {{ getValueDateTime(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'date'">
                                {{ getValueDate(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'ym'">
                                {{ getValueYearMonth(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'time'">
                                {{ getValueTime(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value_from || item.resourceField[0].default_value_to">
                                {{ item.resourceField[0].default_value_from }} ~
                                {{ item.resourceField[0].default_value_to }}
                              </span>
                              <span v-else> -- </span>
                            </dd>
                          </template>
                        </template>
                      </dl>
                    </template>
                  </template>
                  <div class="jobs_search_setting" v-if="freeWord">
                    <div class="jobs_search_condition_label setting_word_break">
                      {{ searchJobLabelsProperty.FREE_WORD }}（
                      <span style="text-transform: uppercase"> {{ condition }} </span>)
                    </div>
                    <div class="jobs_search_condition_desc setting_word_break">
                      <span>
                        {{ freeWord }}
                      </span>
                    </div>
                  </div>
                  <template v-if="!numberOfSearchByItem && !freeWord">
                    <label>
                      {{searchJobLabelsProperty.NONE}}
                    </label>
                  </template>
                </div>
                <div class="jobs_search_condition_btn">
                  <button class="jobs_btn_secondary jobs_btn_medium"
                    v-bind:style="{
                      color: draftColors.subButtonText,
                      backgroundColor: draftColors.subButton
                    }"
                    @click="step = 1, scrollToTopOfModal()">
                    {{ searchJobLabelsProperty.BUTTON_CHANGE_CONDITON_SEARCH }}
                  </button>
                </div>
              </div>
              <div class="jobs_search_result" v-if="numberOfJobDisplay > 0">
                <span class="jobs_search_result_number">
                  {{ numberOfJobDisplay }}
                </span>
                <span class="jobs_search_result_unit">
                  {{ searchJobLabelsProperty.IN_PIECE }}
                </span>
                <span class="jobs_search_result_range">
                  1 ～ {{ numberOfJobDisplay }} {{ searchJobLabelsProperty.SHOW_MATTER }}
                </span>
              </div>

              <div class="jobs_result">
                <ul class="jobs_result_list" v-for="(job, indexJobDetail) in jobDetails" :key="indexJobDetail">
                  <li class="jobs_result_item">
                    <div class="jobs_result_inner">
                      <h2 class="jobs_result_heading" @click="step = 3">
                        <router-link to="" @click.native="scrollToTopOfModal()">
                          <a class="jobs_result_title" v-bind:style="{ color: draftColors.linkText }" style="text-decoration: none">
                            <template v-for="(headingSetting, index) in headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted)">
                                <span :key="'h' + index">
                                  {{ headingSetting.display_name }} <span v-if="index < headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted).length - 1">/</span>
                                </span>
                            </template>
                          </a>
                        </router-link>
                      </h2>
                      <div class="jobs_result_text" v-for="(bodySetting, index) in bodySettings.filter(bodySetting => !bodySetting.itemResourceDeleted)" :key="index">
                        <span :key="'b' + index">
                          {{bodySetting.display_name}}
                        </span>
                      </div>
                      <template v-for="(category, cIndex) in categoriesJobList">
                        <template v-if="category && !category.categoryDeleted && !isEmptyCategory(categoriesJobList, cIndex)">
                          <h2 class="jobs_category_title mt-3" :key="'cl' + cIndex"
                              v-bind:style="{color: draftColors.pageText, borderLeftColor: draftColors.keyColor}">
                            {{ category.categoryName }}
                          </h2>
                          <table class="jobs_detail_table" :key="'cls' + cIndex + indexJobDetail">
                            <tbody class="jobs_detail_table_body">
                              <template v-for="(item, index) in category.item">
                                <tr class="jobs_detail_table_rows"
                                    v-bind:key="item.resourceField[0].name">
                                  <th class="jobs_detail_table_head"
                                      v-bind:style="[{ backgroundColor: draftColors.subColor }, index === 0 ? { border: '1px solid' + draftColors.borderColor } : {borderLeft: '1px solid' + draftColors.borderColor, borderRight: '1px solid' + draftColors.borderColor, borderBottom: '1px solid' + draftColors.borderColor}]">
                                     <span v-bind:style="{ color: draftColors.pageText }" class="setting_word_break">
                                       {{ item.itemName }}
                                     </span>
                                  </th>
                                  <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + draftColors.borderColor, borderRight: '1px solid' + draftColors.borderColor, borderBottom: '1px solid' + draftColors.borderColor}">
                                  </td>
                                </tr>
                              </template>
                             </tbody>
                           </table>
                        </template>
                      </template>
                    </div>
                    <div class="jobs_result_btn">
                      <button
                      v-bind:style="{
                        color: draftColors.mainButtonText,
                        backgroundColor: draftColors.mainButton
                      }"
                      class="jobs_btn_primary" @click="step = 3, scrollToTopOfModal()">
                        <span v-if="button.listBtn === ''">
                          {{ searchJobLabelsProperty.VIEW_DETAIL_JOB }}
                        </span>
                        <span v-else>
                          {{ button.listBtn }}
                        </span>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="jobs_btn_box">
                <button class="jobs_btn_secondary jobs_btn_medium jobs_btn_disabled">
                  {{ searchJobLabelsProperty.BUTTON_BACK_PAGE }}
                </button>
                <button class="jobs_btn_secondary jobs_btn_medium"
                  v-bind:style="{
                    color: draftColors.subButtonText,
                    backgroundColor: draftColors.subButton
                  }"
                >
                  {{ searchJobLabelsProperty.BUTTON_NEXT_PAGE }}
                </button>
              </div>
            </template>

             <template v-if="step === 3">
               <div v-bind:style="{ backgroundColor: draftColors.pageBackground }">
              <h1 class="jobs_page_title jobs_page_title_customize" v-bind:style="{ color: draftColors.pageText }">
                <template v-for="(headingSetting, index) in headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted)">
                   <span :key="'h' + index">
                    {{headingSetting.display_name}} <span v-if="index < headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted).length - 1">/</span>
                   </span>
                </template>
              </h1>

              <div class="jobs_detail_text" v-bind:style="{ color: draftColors.pageText }"
                  v-for="(bodySetting, index) in bodySettings" :key="index">
                  <span :key="'b' + index">
                    {{bodySetting.display_name}}
                   </span>
              </div>

              <template v-for="(category, cIndex) in categoriesJobDetail">
                <template v-if="category && !category.categoryDeleted && !isEmptyCategory(categoriesJobDetail, cIndex)">
                  <h2 class="jobs_category_title" :key="'cd' + cIndex"
                      v-bind:style="{color: draftColors.pageText, borderLeftColor: draftColors.keyColor}">
                    {{ category.categoryName }}
                  </h2>
                  <div class="jobs_table_wrapper" :key="'tb' + cIndex">
                    <table class="jobs_detail_table">
                      <tbody class="jobs_detail_table_body">
                         <template v-for="(item, index) in category.item">
                           <tr class="jobs_detail_table_rows"
                               v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: draftColors.subColor }, index === 0 ? { border: '1px solid' + draftColors.borderColor } : {borderLeft: '1px solid' + draftColors.borderColor, borderRight: '1px solid' + draftColors.borderColor, borderBottom: '1px solid' + draftColors.borderColor}]">
                              <span v-bind:style="{ color: draftColors.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + draftColors.borderColor, borderRight: '1px solid' + draftColors.borderColor, borderBottom: '1px solid' + draftColors.borderColor}">
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                 </template>
              </template>

              <div class="jobs_btn_box" v-if="commonSetting">
                <button v-if="commonSetting.jobInquiryUrl" class="jobs_btn_primary"
                        v-bind:style="{color: draftColors.mainButtonText, backgroundColor: draftColors.mainButton, border: '1px solid' + draftColors.borderColor}">
                   <span v-if="button.contactBtn === ''">
                     {{ searchJobLabelsProperty.BUTTON_CONTACT }}
                   </span>
                  <span v-else>
                     {{ button.contactBtn }}
                   </span>
                </button>
                <button v-if="commonSetting.entryPublic" class="jobs_btn_primary"
                        v-bind:style="{color: draftColors.mainButtonText, backgroundColor: draftColors.mainButton, border: '1px solid' + draftColors.borderColor}">
                   <span v-if="button.detailBtn === ''">
                     {{ searchJobLabelsProperty.BUTTON_APPLY_JOB }}
                   </span>
                  <span v-else>
                     {{ button.detailBtn }}
                   </span>
                </button>
              </div>
              <div class="jobs_detail_back">
                <button class="jobs_btn_secondary jobs_btn_medium" @click="step = 2, scrollToTopOfModal()"
                        v-bind:style="{color: draftColors.subButtonText, backgroundColor: draftColors.subButton, border: '1px solid' + draftColors.borderColor,}">
                  {{ searchJobLabelsProperty.RETURN_JOB_SEARCH_TOP }}
                </button>
               </div>
            </div>
             </template>
           </div>
         </div>
       </div>
       <div class="setting_customize_footer">
         <div class="setting_customize_footer_delete">
          <button
            @click="openConfirmRemoveTheme"
            class="setting_customize_footer_delete_button"
            :class="isShowRemoveTheme ? 'is_disabled' : ''"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 1024 1024"
              fill="#f16a6a"
            >
               <path
                d="M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"
              />
             </svg>
             {{ labelProperties.BUTTON_DELETE_THEME }}
           </button>
          <div class="setting_modal" v-if="isOpenConfirmModal">
            <div class="setting_modal_box_customer">
              <div class="setting_modal_box_body_cusomer">
                <p class="setting_modal_box_text">
                  {{ labelProperties.MESSAGE_CONFIRM_DELETE_THEME }}
                </p>
              </div>
              <div class="setting_modal_box_actions_customer">
                <button
                  class="setting_btn_outline mr-2"
                  @click="cancelDeleteCustomizeTheme"
                >
                   {{ labelProperties.BUTTON_CANCEL_DELETE_THEME }}
                 </button>
                <button
                  class="setting_btn_primary"
                  @click="acceptRemoveTheme()"
                >
                   {{ labelProperties.BUTTON_OK_DELETE_THEME }}
                 </button>
              </div>
            </div>
          </div>
        </div>
         <div class="setting_customize_footer_button">
          <button
            class="setting_btn_outline setting_btn_small"
            @click="cancel"
          >
             {{ labelProperties.BUTTON_CLOSE_MODAL }}
           </button>
          <button
            class="setting_btn_primary setting_btn_small"
            @click="saveAsDraft"
          >
             {{ labelProperties.BUTTON_REFLECT }}
           </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InputComponent from "../../../GeneralComponents/InputComponent.vue";
import VueToast from "vue-toast-notification";
import labelProperties from "../../../../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";
import messageProperties from "../../../../../properties/job_screen/customize_tab/popup-customize/popup-customize-message.json";
import maxlengthProperties from "../../../../../properties/job_screen/customize_tab/popup-customize/popup-customize-maxlength.json";
import * as generalLabels from "../../../../../properties/general_page/generalpage-labels.json";
import * as jobSettingProperty from "../../../../../properties/job_screen/job-screen.json";
import generalService from "../../../../../services/GeneralService";
import labelCustomizeEntryProperties from "../../../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import searchJobLabelsProperty from "../../../../../properties/user_search_job_screen/search-job-labels.json";
import moment from "moment";

Vue.use(VueToast);

export default {
  name: "CustomizeScreenModal",
  props: [
    "categoriesSearchJob",
    "colors",
    "masters",
    "button",
    "draftColors",
    "isShowRemoveTheme",
    "jobPageName",
    "jobOverview",
    "groupName",
    "userId",
    "optionCustomizeColor",
    "numberOfJobDisplay",
    "headingSettings",
    "bodySettings",
    "categoriesJobList",
    "categoriesJobDetail",
    "commonSetting"
  ],
  components: {
    InputComponent,
  },
  data: function () {
    return {
      condition: "or",
      messages: [],
      master: [],
      step: 1,
      resource: {},
      colorSettings: [
        {
          id: 1,
          name: labelCustomizeEntryProperties.BACKGROUND_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 2,
          name: labelCustomizeEntryProperties.KEY_COLOR,
          color: "#0D0D0D",
        },
        {
          id: 3,
          name: labelCustomizeEntryProperties.SUB_COLOR,
          color: "#FCFCFC",
        },
        {
          id: 4,
          name: labelCustomizeEntryProperties.BORDER_COLOR,
          color: "#E8E3E3",
        },
        {
          id: 5,
          name: labelCustomizeEntryProperties.TEXT_COLOR,
          color: "#0D0D0D",
        },
        {
          id: 6,
          name: labelCustomizeEntryProperties.LINK_TEXT_COLOR,
          color: "#3090D9",
        },
        {
          id: 7,
          name: labelCustomizeEntryProperties.MAIN_BUTTON_COLOR,
          color: "#F36A07",
        },
        {
          id: 8,
          name: labelCustomizeEntryProperties.MAIN_BUTTON_TEXT_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 9,
          name: labelCustomizeEntryProperties.SUB_BUTTON_COLOR,
          color: "#F8F7F7",
        },
        {
          id: 10,
          name: labelCustomizeEntryProperties.SUB_BUTTON_TEXT_COLOR,
          color: "#000000",
        },
      ],
      isDisableEditing: false,
      isOpenConfirmModal: false,
      isEmptyThemeName: false,
      isOverThemeNameLength: false,
      labelProperties: labelProperties,
      messageProperties: messageProperties,
      maxlengthProperties: maxlengthProperties,
      labelCustomizeEntryProperties:labelCustomizeEntryProperties,
      searchJobLabelsProperty: searchJobLabelsProperty,
      log: {
        info: {},
      },
      freeWord: "",
      numberOfSearchByItem: 0,
      jobDetails: [],
    };
  },
  updated() {
    this.updateColorSettings();
  },
  methods: {
    scrollToTopOfModal(){
      document.getElementById("top_modal_customize").scrollIntoView();
    },

    isEmptyCategory(categoriesJob, index) {
      return (!categoriesJob || !categoriesJob[index] || categoriesJob[index].item.length === 0);
    },

    searchJob(){
      this.jobDetails = Array.from(Array(Number(this.numberOfJobDisplay)), (d, i) => i + 1);
      this.checkItemSearchHasValue();
      this.step = 2;
      this.scrollToTopOfModal();
    },
    checkItemSearchHasValue() {
      this.numberOfSearchByItem = 0;
      this.categoriesSearchJob.forEach(category => category.item.filter(itemJob => itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
        itemJob.resourceField.forEach(resource => {
          if (resource.type === "checkbox" || resource.type === "multi_select") {
            resource['isHasValue'] = resource && resource.default_value && resource.default_value.length;
          } else {
            resource['isHasValue'] = resource && (resource.default_value || resource.default_value_from || resource.default_value_to);
          }
          resource['isHasValue'] ? this.numberOfSearchByItem++ : this.numberOfSearchByItem;
        });
      }));
    },
    getValueTime(value) {
      let timeFrom = "";
      let timeTo = "";
      if (value.default_value_from) {
        timeFrom = moment(value.default_value_from).format("HH:mm");
      }

      if (value.default_value_to) {
        timeTo = moment(value.default_value_to).format("HH:mm");
      }

      let stringTime = "";
      if (timeFrom !== "" && timeTo !== "") {
        stringTime = timeFrom + " ~ " + timeTo;
      }

      if (timeFrom !== "" && timeTo === "") {
        stringTime = timeFrom;
      }

      if (timeFrom === "" && timeTo !== "") {
        stringTime = timeTo;
      }

      if (stringTime === "") {
        stringTime = "--";
      }

      return stringTime;
    },

    getValueYearMonth(value) {
      let ymFrom = "";
      let ymTo = "";
      if (value.default_value_from) {
        ymFrom = moment(value.default_value_from).format("yyyy/MM");
      }

      if (value.default_value_to) {
        ymTo = moment(value.default_value_to).format("yyyy/MM");
      }

      let stringYM = "";
      if (ymFrom !== "" && ymTo !== "") {
        stringYM = ymFrom + " ~ " + ymTo;
      }

      if (ymFrom !== "" && ymTo === "") {
        stringYM = ymFrom;
      }

      if (ymFrom === "" && ymTo !== "") {
        stringYM = ymTo;
      }

      if (stringYM === "") {
        stringYM = "--";
      }

      return stringYM;
    },

    getValueDate(value) {
      let dateFrom = "";
      let dateTo = "";
      if (value.default_value_from) {
        dateFrom = moment(value.default_value_from).format("YYYY-MM-DD");
      }

      if (value.default_value_to) {
        dateTo = moment(value.default_value_to).format("YYYY-MM-DD");
      }

      let stringDate = "";
      if (dateFrom !== "" && dateTo !== "") {
        stringDate = dateFrom + " ~ " + dateTo;
      }

      if (dateFrom !== "" && dateTo === "") {
        stringDate = dateFrom;
      }

      if (dateFrom === "" && dateTo !== "") {
        stringDate = dateTo;
      }

      if (stringDate === "") {
        stringDate = "--";
      }

      return stringDate;
    },
    getValueDateTime(value) {
      let dateTimeFrom = "";
      let dateTimeTo = "";
      if (value.default_value_from) {
        dateTimeFrom = moment(value.default_value_from).format("YYYY-MM-DD HH:mm");
      }

      if (value.default_value_to) {
        dateTimeTo = moment(value.default_value_to).format("YYYY-MM-DD HH:mm");
      }

      let stringDateTime = "";
      if (dateTimeFrom !== "" && dateTimeTo !== "") {
        stringDateTime = dateTimeFrom + " ~ " + dateTimeTo;
      }

      if (dateTimeFrom !== "" && dateTimeTo === "") {
        stringDateTime = dateTimeFrom;
      }

      if (dateTimeFrom === "" && dateTimeTo !== "") {
        stringDateTime = dateTimeTo;
      }

      if (stringDateTime === "") {
        stringDateTime = "--";
      }

      return stringDateTime;
    },

    getValueCheckBox(values) {
      let valuesChecked = [];
      values.forEach(value => {
        if (!valuesChecked.includes(value)) {
          if (value.choiceDisplayName) {
            valuesChecked.push(value.choiceDisplayName);
          } else {
            valuesChecked.push(value.choiceName);
          }
        }
      });

      return valuesChecked.join(", ");
    },

    getSingleSelect(resource) {
      if (!resource || !resource.default_value) {
        return "--";
      }

      if (resource.name === 'company_id' || resource.name === 'staff_id' || resource.name === 'user_id') {
        return resource.default_value;
      }

      if (!resource.default_value.show) {
        return "--";
      }

      let value = resource.default_value;
      return value.choiceDisplayName ? value.choiceDisplayName : value.choiceName;
    },

    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master_name === master) {
          return [...this.masters[master].items];
        }
      }
    },

    handleChangeColor(position, colorCode) {
      switch (position) {
        case labelCustomizeEntryProperties.BACKGROUND_COLOR:
          this.draftColors.pageBackground = colorCode.toUpperCase();
          this.colorSettings[0].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.KEY_COLOR:
          this.draftColors.keyColor = colorCode.toUpperCase();
          this.colorSettings[1].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.SUB_COLOR:
          this.draftColors.subColor = colorCode.toUpperCase();
          this.colorSettings[2].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.BORDER_COLOR:
          this.draftColors.borderColor = colorCode.toUpperCase();
          this.colorSettings[3].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.TEXT_COLOR:
          this.draftColors.pageText = colorCode.toUpperCase();
          this.colorSettings[4].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.LINK_TEXT_COLOR:
          this.draftColors.linkText = colorCode.toUpperCase();
          this.colorSettings[5].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.MAIN_BUTTON_COLOR:
          this.draftColors.mainButton = colorCode.toUpperCase();
          this.colorSettings[6].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.MAIN_BUTTON_TEXT_COLOR:
          this.draftColors.mainButtonText = colorCode.toUpperCase();
          this.colorSettings[7].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.SUB_BUTTON_COLOR:
          this.draftColors.subButton = colorCode.toUpperCase();
          this.colorSettings[8].color = colorCode.toUpperCase();
          break;
        case labelCustomizeEntryProperties.SUB_BUTTON_TEXT_COLOR:
          this.draftColors.subButtonText = colorCode.toUpperCase();
          this.colorSettings[9].color = colorCode.toUpperCase();
          break;
      }
    },
    updateColorSettings() {
      this.colorSettings[0].color = this.draftColors.pageBackground;
      this.colorSettings[1].color = this.draftColors.keyColor;
      this.colorSettings[2].color = this.draftColors.subColor;
      this.colorSettings[3].color = this.draftColors.borderColor;
      this.colorSettings[4].color = this.draftColors.pageText;
      this.colorSettings[5].color = this.draftColors.linkText;
      this.colorSettings[6].color = this.draftColors.mainButton;
      this.colorSettings[7].color = this.draftColors.mainButtonText;
      this.colorSettings[8].color = this.draftColors.subButton;
      this.colorSettings[9].color = this.draftColors.subButtonText;
    },
    saveAsDraft() {
      this.isEmptyThemeName = false;
      this.isOverThemeNameLength = false;
      if (this.draftColors && !this.draftColors.themeName) {
        this.isEmptyThemeName = true;
        this.$refs.themeName.focus();
        return;
      }

      if (
        this.draftColors.themeName &&
        this.draftColors.themeName.length > 45
      ) {
        this.isOverThemeNameLength = true;
        this.$refs.themeName.focus();
        return;
      }
      this.$eventBus.$emit("unSaved", true);
      this.$emit("updateCustomizeSettings", this.draftColors);
      this.step = 1;
    },

    cancel() {
      this.isEmptyThemeName = false;
      this.isOverThemeNameLength = false;
      this.$emit("close", this.colors);
      this.step = 1;
    },

     async openConfirmRemoveTheme() {
      await this.$emit(
        "setLoggerData",
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.COLOR_THEME_TAB_TITLE +
          "-Popup " +
          labelProperties.HEAD_MODAL +
          "-Click button " +
          labelProperties.BUTTON_DELETE_THEME
      );
       this.isOpenConfirmModal = true;
     },

     async acceptRemoveTheme() {
       this.log.groupName = this.groupName;
       this.log.hash = generalService.createHashCode(15);
      this.log.info.action =
        "Menu " +
        generalLabels.THIRD_TAB +
        "-Tab " +
        jobSettingProperty.COLOR_THEME_TAB_TITLE +
        "-Popup " +
        labelProperties.HEAD_MODAL +
        "-Popup confirm delete theme" +
        "-Click button " +
        labelProperties.BUTTON_OK_DELETE_THEME;
       this.log.info.path = window.location.href;
       this.log.info.userId = this.userId;
       await this.sendLogger(this.log);

       this.$emit("remove", this.log.hash);
       this.isOpenConfirmModal = false;
     },
     async cancelDeleteCustomizeTheme() {
      await this.$emit(
        "setLoggerData",
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.COLOR_THEME_TAB_TITLE +
          "-Popup " +
          labelProperties.HEAD_MODAL +
          "-Popup confirm delete theme" +
          "-Click button " +
          labelProperties.BUTTON_CANCEL_DELETE_THEME
      );
       this.isOpenConfirmModal = false;
     },
     async sendLogger(loggerData) {
       this.logs = loggerData;
      await generalService
        .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
        .then((response) => {
          if (response.status === 200) {
            return true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
     },

    isEmptyCategoryInJobSearch(index) {
      if (this.categoriesSearchJob[index].item.length === 0) {
        return true;
      }

      return this.categoriesSearchJob[index].item.filter(item => !item.resourceField[0].isDeletedByMainSystem).length === 0;
    },
  },
};
</script>

<style lang="css" scoped>
.jobs_table_wrapper {
  margin-bottom: 32px;
}

.jobs_table {
  display: table;
  table-layout: fixed;
  width: 100%;
  border-top: 1px solid #ddd;
}

.jobs_table_head,
.jobs_table_cell {
  padding: 16px;
}

.jobs_table_head {
  display: table-cell;
  width: 300px;
  background-color: #f7f7f7;
}

.jobs_table_cell {
  display: block;
  padding-top: 0;
  width: 100%;
}

.setting_modal_box_customer {
  top: 0 !important;
  background-color: #fff;
  padding: 24px;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 420px;
  border: 1px solid rgb(143, 141, 141);
}

.setting_modal_box_body_cusomer {
  padding: 10px 0;
}

.setting_modal_box_actions_customer {
  display: -webkit-box;
  -webkit-box-align: end;
  -webkit-box-pack: end;
}

.empty-theme-name {
  color: red;
}

.setting_customize_header_title {
  align-self: self-start !important;
}

.setting_content_heading_btn_holder > * + * {
  margin-left: 0 !important ;
}

p {
  margin-bottom: 0 !important;
}

.jobs_search_setting{
  display: -webkit-box;
}

.jobs_page_title_customize {
  margin-bottom: 12px !important;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}

.jobs_page_title{
  margin-bottom: 12px !important;
}

.setting_word_break {
  word-break: break-all;
}
</style>
